<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel">
    <header class="topbar">
      <h1>Plataforma Única de Postulación</h1>
      <div class="topbar-right">
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>

    <app-inicio-concursos-panel
      *ngIf="mostrarConcursos; else panelNovedades"
      [rolSeleccionado]="rolSeleccionado"
    ></app-inicio-concursos-panel>

    <ng-template #panelNovedades>
      <app-principal-dashboard-panel [rolSeleccionado]="rolSeleccionado"></app-principal-dashboard-panel>
    </ng-template>
  </div>
</div>
